import React, { FC } from 'react'

// Images
import { ReactComponent as Logo } from 'icons/logo-black.svg'

// Styles
import {
  MainContainer,
  Header,
  Container,
  Title,
  RecoveryCodesContainer,
} from './RecoveryCodesPDFTemplate.styles'

// Types
interface RecoveryCodesPDFTemplateProps {
  recoveryCodes: string[]
}

/**
 * RecoveryCodesPDFTemplate
 *
 * Renders the recovery codes PDF template
 */
const RecoveryCodesPDFTemplate: FC<RecoveryCodesPDFTemplateProps> = ({
  recoveryCodes,
}) => (
  <MainContainer>
    <Header>
      <Logo height="41px" />
      <Title>Sketch</Title>
    </Header>
    <Container>
      <Title>Recovery&nbsp;Codes</Title>
      <RecoveryCodesContainer>
        {recoveryCodes.map(code => (
          <div key={code}>{code}</div>
        ))}
      </RecoveryCodesContainer>
    </Container>
  </MainContainer>
)

export default RecoveryCodesPDFTemplate
